module.exports = __webpack_public_path__ + "img/img_shop_notchoose.5d63af98.png";